<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content>
  <app-organisational-level-form
    [companyId]="companyId()"
    [initialValue]="initialValue()"
    [saving]="saving()"
    (submitted)="onSubmit($event)" />
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="onCancel()">Cancel</button>
</mat-dialog-actions>